import React from "react";
import SVGMorph from "../SVGMorph";
import { pose1, pose2, pose3 } from "./path";

function Pose({ duration, delay }) {
  return (
    <svg
      width="198"
      height="357"
      viewBox="0 0 198 357"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <SVGMorph
        paths={[pose1, pose2, pose3]}
        duration={duration}
        delay={delay}
      />
    </svg>
  );
}

export default Pose;
